export enum ApplicationQueryParamsEnum {
  STORE_UUID = 'storeUuid',
  APPOINTMENT_UUID = 'appointmentUuid',
  PAYMENT_STATUS = 'paymentStatus',
}
